import { StyledItemName, StyledSecondaryName } from "./styles";
import type { TechnologiesDDItemType } from "../../../../../sub-modules/advanced-search/models/filters/technology/types";
import type { DropdownWithTabsItemProps } from "./DropdownWithTabsItem";
import DropdownWithTabsItem from "./DropdownWithTabsItem";
import { escapeRegExpCharacters } from "../../../../../sub-modules/advanced-search/helpers/common";

type DropdownHighlightedItemProps = Omit<DropdownWithTabsItemProps, "renderText">;

const DropdownWithTabsHighlightedItem = (props: DropdownHighlightedItemProps) => {
    const replaceMatchWithSpanTag = (string: string, match?: string) => {
        if (typeof match === "undefined") {
            return string;
        }

        return string.replace(RegExp(escapeRegExpCharacters(match), "gi"), `<span class="highlighted">${match}</span>`);
    };

    const renderItemText = (item: TechnologiesDDItemType) => {
        const secondaryName = !item.secondaryName ? null : (
            <StyledSecondaryName>
                <span
                    dangerouslySetInnerHTML={{
                        __html: replaceMatchWithSpanTag(item.secondaryName, item.secondaryNameMatch),
                    }}
                />
            </StyledSecondaryName>
        );
        const primaryName = (
            <span>
                <span
                    dangerouslySetInnerHTML={{
                        __html: replaceMatchWithSpanTag(item.name, item.nameMatch),
                    }}
                />
                {item.technologiesCount ? <span>&nbsp;({item.technologiesCount})</span> : null}
            </span>
        );

        return (
            <StyledItemName>
                {primaryName}
                {secondaryName}
            </StyledItemName>
        );
    };

    return (
        <DropdownWithTabsItem
            {...props}
            renderText={renderItemText}
        />
    );
};

export default DropdownWithTabsHighlightedItem;
